import '@selectize/selectize/dist/js/selectize';

function showFiltersForm() {
    $('.covid-banner, .seo-container, .mobile-filters-preview, .companies-container, .intro-container, .footer').hide();
    $('.search-area, .mobile-search-cta').show();
}

function hideFiltersForm() {
    $('.search-area, .mobile-search-cta').hide();
    $('.covid-banner, .seo-container, .footer, .mobile-filters-preview, .companies-container, .intro-container').show();
}

if ($('#companies-datatable').length) {
    $('#state').selectize({
        plugins: {remove_button: {label: '<i class="mdi mdi-close"></i>'}},
        delimiter: ',',
        persist: false,
        create: false,
        score: function (search) {
            return function (item) {
                if (item.text.toLowerCase().indexOf(search.toLowerCase()) >= 0) {
                    return 1;
                }

                return 0;
            };
        },
    });

    // Handle mobile filters
    $('#show_filters_btn').on('click', showFiltersForm);
    $('#close_filters_btn').on('click', hideFiltersForm);

    // Search form submission
    $('#search_btn, #mobile_search_btn').on('click', function () {
        $(this).attr('disabled', 'disabled');
        $('.basic-search').submit();
    });
}
